function a(n, t) {
  return new a.InputMask(n, t);
}
export {
  a as default
};
